import { createContext, useContext } from "react";
import { useSelector } from "react-redux";

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const userData = useSelector((state) => state.auth.user);

  return (
    <ProfileContext.Provider value={{ userData }}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfileContext = () => {
  return useContext(ProfileContext);
};
